import { render, staticRenderFns } from "./TurmasBolsaFamilia.vue?vue&type=template&id=0074e66c"
import script from "./TurmasBolsaFamilia.vue?vue&type=script&lang=js"
export * from "./TurmasBolsaFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports